import script from "./InvoiceManagementView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceManagementView.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceManagementView.vue?vue&type=style&index=0&id=c985ccf0&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.14_vue@3.5.14_typescript@5.8.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c985ccf0"]])

export default __exports__